import React, { FC } from 'react';

import { Layer, Container } from './styles';

const Loader: FC = () => {
  return (
    <Layer>
      <Container className="lds-roller">
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
      </Container>
    </Layer>
  );
};

export default Loader;
